// extracted by mini-css-extract-plugin
export default {"RadioGroup":"BgToLhG6"};